import {
  type EventAttributeSet,
  EventAttributeType,
} from "../../EventAttributeSet";

import { type AttributeValue } from "@/schemas/attribute/AttributeSet";
import { attributeListToMap } from "@/utils/attributes";

export enum EventStatus {
  TENTATIVE = "TENTATIVE",
  CONFIRMED = "CONFIRMED",
  CANCELLED = "CANCELLED",
}

const EVENT_STATUS_OPTIONS: ReadonlyArray<AttributeValue> = [
  { id: EventStatus.CONFIRMED, label: "Confirmed", iconLabel: "🟢" },
  { id: EventStatus.TENTATIVE, label: "Tentative", iconLabel: "🟡" },
  { id: EventStatus.CANCELLED, label: "Cancelled", iconLabel: "🔴" },
];

export const EventStatusSet: EventAttributeSet = {
  id: EventAttributeType.STATUS,
  isMultiSelect: true,
  map: attributeListToMap(EVENT_STATUS_OPTIONS),
} as const;
